module.exports = __webpack_public_path__ + "static/media/photo4.3db7eff7.png";